import LoadingButton from '@mui/lab/LoadingButton';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { type FC, useEffect, useState } from 'react';

interface ShiftScopeDialogProps {
  open: boolean;
  title: string;
  options: { value: string; label: string }[];
  defaultValue: string;
  actionLabel: string;
  actionColor?: 'primary' | 'error';
  loading?: boolean;
  onConfirm: (scope: string) => void;
  onCancel: () => void;
}

const ShiftScopeDialog: FC<ShiftScopeDialogProps> = ({
  open,
  title,
  options,
  defaultValue,
  actionLabel,
  actionColor,
  loading,
  onConfirm,
  onCancel,
}) => {
  const [scope, setScope] = useState(defaultValue);

  useEffect(() => {
    if (open) {
      setScope(defaultValue);
    }
  }, [open, defaultValue]);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <RadioGroup value={scope} onChange={(_, v) => setScope(v)}>
          {options.map((opt) => (
            <FormControlLabel key={opt.value} value={opt.value} control={<Radio />} label={opt.label} />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <LoadingButton
          variant="contained"
          color={actionColor ?? 'primary'}
          loading={loading}
          onClick={() => onConfirm(scope)}
        >
          {actionLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ShiftScopeDialog;
